import './PeriscopeAnalysisModal.scss';
import { AnalysisCard } from './AnalysisCard';
import { PeriscopeSummary } from './PeriscopeSummary';
import React from 'react';
import { resetAnalysisPeriscope } from '../../global/redux/application/actions';
import { Modal, Space } from 'antd';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
import { useAction, useSonarSelector } from '@hooks';
export const PeriscopeAnalysisModal = () => {
    var _a, _b;
    const target = useSonarSelector((state) => state.application.periscope.analysisTarget);
    const close = useAction(resetAnalysisPeriscope);
    const sonarObjectId = (_a = target === null || target === void 0 ? void 0 : target.id) !== null && _a !== void 0 ? _a : 0;
    const type = (_b = target === null || target === void 0 ? void 0 : target.type) !== null && _b !== void 0 ? _b : SonarObjectType.SalesforceApexClass;
    const periscope = {
        id: sonarObjectId,
        name: '',
        type
    };
    return (React.createElement(Modal, { className: 'periscope-analysis-modal', closable: true, destroyOnHidden: true, footer: null, onCancel: close, open: Boolean(target) },
        React.createElement(Space, { className: 'periscope-analysis-modal-view' },
            React.createElement(PeriscopeSummary, { index: 0, periscope: periscope }),
            React.createElement(AnalysisCard, { sonarObjectId: sonarObjectId, type: type }))));
};
